import type { PlanFeatureKey } from 'Types/plan'

export type ReportsNavItem = {
 id: string
 path: string
 labelKey: string
 navLabelKey?: string
 sidebarIcon: string
 feature?: PlanFeatureKey
}

export type ReportsNavSection = {
 id: string
 labelKey: string
 items: ReportsNavItem[]
}

export const REPORTS_NAV_SECTIONS: ReportsNavSection[] = [
 {
  id: 'salesGeneral',
  labelKey: 'reports.sections.salesGeneral',
  items: [
   { id: 'nav-rep-overview', path: 'overview', labelKey: 'reports.overview.nav', sidebarIcon: 'ri-file-list-3-line' },
   { id: 'nav-rep-sales-dash', path: 'sales/dashboard', labelKey: 'nav.reports.salesDashboard', sidebarIcon: 'ri-file-list-3-line' },
   { id: 'nav-rep-sales-refunds', path: 'sales/refunds', labelKey: 'nav.reports.salesRefunds', sidebarIcon: 'ri-receipt-line' },
   { id: 'nav-rep-sales-tax', path: 'sales/tax', labelKey: 'nav.reports.salesTax', sidebarIcon: 'ri-bank-line' },
   { id: 'nav-rep-sales-layaway', path: 'sales/layaway', labelKey: 'nav.reports.salesLayaway', sidebarIcon: 'ri-time-line' },
   { id: 'nav-rep-sales-hourly', path: 'sales/hourly', labelKey: 'nav.reports.salesHourly', sidebarIcon: 'ri-file-list-3-line' },
  ],
 },
 {
  id: 'categoryReports',
  labelKey: 'reports.sections.categoryReports',
  items: [
   { id: 'nav-rep-sales-by-cat', path: 'sales/by-category', labelKey: 'nav.reports.salesByCategory', navLabelKey: 'reports.nav.sales', sidebarIcon: 'ri-file-list-3-line' },
   { id: 'nav-rep-sales-cat-detail', path: 'sales/category-detail', labelKey: 'nav.reports.salesCategoryDetail', navLabelKey: 'reports.nav.detail', sidebarIcon: 'ri-search-line' },
   { id: 'nav-rep-sales-ret-by-cat', path: 'sales-returns-by-category', labelKey: 'nav.reports.salesReturnsByCategory', navLabelKey: 'reports.nav.salesReturns', sidebarIcon: 'ri-receipt-line' },
   { id: 'nav-rep-purch-ret-by-cat', path: 'purchase-returns-by-category', labelKey: 'nav.reports.purchaseReturnsByCategory', navLabelKey: 'reports.nav.purchaseReturns', sidebarIcon: 'ri-arrow-go-back-line' },
  ],
 },
 {
  id: 'productReports',
  labelKey: 'reports.sections.productReports',
  items: [
   { id: 'nav-rep-sales-by-prod', path: 'sales/by-product', labelKey: 'nav.reports.salesByProduct', navLabelKey: 'reports.nav.sales', sidebarIcon: 'ri-shopping-bag-line' },
   { id: 'nav-rep-sales-prod-detail', path: 'sales/product-detail', labelKey: 'nav.reports.salesProductDetail', navLabelKey: 'reports.nav.detail', sidebarIcon: 'ri-search-line' },
   { id: 'nav-rep-sales-ret-by-prod', path: 'sales-returns-by-product', labelKey: 'nav.reports.salesReturnsByProduct', navLabelKey: 'reports.nav.salesReturns', sidebarIcon: 'ri-receipt-line' },
   { id: 'nav-rep-purch-ret-by-prod', path: 'purchase-returns-by-product', labelKey: 'nav.reports.purchaseReturnsByProduct', navLabelKey: 'reports.nav.purchaseReturns', sidebarIcon: 'ri-arrow-go-back-line' },
  ],
 },
 {
  id: 'financialReports',
  labelKey: 'reports.sections.financialReports',
  items: [
   { id: 'nav-rep-treasury', path: 'treasury', labelKey: 'nav.reports.treasury', sidebarIcon: 'ri-safe-2-line', feature: 'advanced_reports' },
   { id: 'nav-rep-financial-accounts', path: 'financial-accounts', labelKey: 'nav.reports.financialAccounts', sidebarIcon: 'ri-bank-card-line', feature: 'advanced_reports' },
   { id: 'nav-rep-expenses', path: 'expenses', labelKey: 'nav.reports.expenses', sidebarIcon: 'ri-bank-line', feature: 'advanced_reports' },
   { id: 'nav-rep-profit-loss', path: 'profit-loss', labelKey: 'nav.reports.profitLoss', sidebarIcon: 'ri-line-chart-line', feature: 'advanced_reports' },
   { id: 'nav-rep-budget-vs-actual', path: 'budget-vs-actual', labelKey: 'nav.reports.budgetVsActual', sidebarIcon: 'ri-funds-line', feature: 'advanced_reports' },
   { id: 'nav-rep-expenses-detail', path: 'expenses/detail', labelKey: 'nav.reports.expensesDetail', sidebarIcon: 'ri-money-dollar-circle-line' },
  ],
 },
 {
  id: 'inventoryReports',
  labelKey: 'reports.sections.inventoryReports',
  items: [
   { id: 'nav-rep-inv-val', path: 'inventory/valuation', labelKey: 'nav.reports.inventoryValuation', sidebarIcon: 'las la-boxes' },
   { id: 'nav-rep-inv-mov', path: 'inventory/movements', labelKey: 'nav.reports.inventoryMovements', sidebarIcon: 'ri-clipboard-fill' },
   { id: 'nav-rep-inv-expiry', path: 'inventory/expiry', labelKey: 'nav.reports.inventoryExpiry', sidebarIcon: 'las la-boxes' },
   { id: 'nav-rep-raw-materials', path: 'inventory/raw-materials', labelKey: 'nav.reports.rawMaterials', sidebarIcon: 'ri-flask-line' },
   { id: 'nav-rep-inv-counts', path: 'inventory/stock-counts', labelKey: 'nav.reports.stockCounts', sidebarIcon: 'ri-checkbox-circle-line' },
   { id: 'nav-rep-inv-adjustments', path: 'inventory/stock-adjustments', labelKey: 'nav.reports.stockAdjustments', sidebarIcon: 'ri-edit-circle-line' },
   { id: 'nav-rep-inv-transfers', path: 'inventory/stock-transfers', labelKey: 'nav.reports.stockTransfers', sidebarIcon: 'ri-exchange-line' },
   { id: 'nav-rep-inv-warehouse', path: 'inventory/warehouse-utilization', labelKey: 'nav.reports.warehouseUtilization', sidebarIcon: 'ri-store-2-line' },
   { id: 'nav-rep-recipes', path: 'recipes', labelKey: 'nav.reports.recipes', sidebarIcon: 'ri-restaurant-line' },
   { id: 'nav-rep-products-variants', path: 'products/variants', labelKey: 'nav.reports.productVariants', sidebarIcon: 'ri-shapes-line' },
  ],
 },
 {
  id: 'customersSuppliers',
  labelKey: 'reports.sections.customersSuppliers',
  items: [
   { id: 'nav-rep-cust-aging', path: 'customers/aging', labelKey: 'nav.reports.customerAging', sidebarIcon: 'ri-user-line' },
   { id: 'nav-rep-cust-loyalty', path: 'customers/loyalty', labelKey: 'nav.reports.customerLoyalty', sidebarIcon: 'ri-star-line' },
   { id: 'nav-rep-cust-wallet', path: 'customers/wallet', labelKey: 'nav.reports.customerWallet', sidebarIcon: 'ri-wallet-3-line' },
   { id: 'nav-rep-sup-aging', path: 'suppliers/aging', labelKey: 'nav.reports.supplierAging', sidebarIcon: 'ri-truck-line' },
   { id: 'nav-rep-sup-payments', path: 'suppliers/payments', labelKey: 'nav.reports.supplierPayments', sidebarIcon: 'ri-bank-card-line' },
   { id: 'nav-rep-sup-requisitions', path: 'suppliers/requisitions', labelKey: 'nav.reports.supplierRequisitions', sidebarIcon: 'ri-file-text-line' },
  ],
 },
 {
  id: 'diningDelivery',
  labelKey: 'reports.sections.diningDelivery',
  items: [
   { id: 'nav-rep-dining', path: 'dining', labelKey: 'nav.reports.dining', sidebarIcon: 'ri-restaurant-line' },
   { id: 'nav-rep-dining-reservations', path: 'dining/reservations', labelKey: 'nav.reports.diningReservations', sidebarIcon: 'ri-calendar-line' },
   { id: 'nav-rep-delivery', path: 'delivery', labelKey: 'nav.reports.delivery', sidebarIcon: 'ri-truck-line' },
  ],
 },
 {
  id: 'marketingGifts',
  labelKey: 'reports.sections.marketingGifts',
  items: [
   { id: 'nav-rep-mkt-coupons', path: 'marketing/coupons', labelKey: 'nav.reports.marketingCoupons', sidebarIcon: 'ri-file-list-line' },
   { id: 'nav-rep-mkt-promo', path: 'marketing/promotions', labelKey: 'nav.reports.marketingPromotions', sidebarIcon: 'ri-price-tag-3-line' },
   { id: 'nav-rep-gift', path: 'gift-cards', labelKey: 'nav.reports.giftCards', sidebarIcon: 'ri-gift-line' },
  ],
 },
 {
  id: 'operations',
  labelKey: 'reports.sections.operations',
  items: [
   { id: 'nav-rep-shifts', path: 'shifts', labelKey: 'nav.reports.shifts', sidebarIcon: 'ri-time-line', feature: 'advanced_reports' },
   { id: 'nav-rep-ops-driver', path: 'operations/driver-settlements', labelKey: 'nav.reports.driverSettlements', sidebarIcon: 'ri-steering-2-line' },
   { id: 'nav-rep-ops-cash-drawer', path: 'operations/cash-drawer', labelKey: 'nav.reports.cashDrawer', sidebarIcon: 'ri-money-cny-circle-line' },
   { id: 'nav-rep-ops-kitchen', path: 'operations/kitchen-performance', labelKey: 'nav.reports.kitchenPerformance', sidebarIcon: 'ri-fire-line' },
   { id: 'nav-rep-ops-offline-sync', path: 'operations/offline-sync', labelKey: 'nav.reports.offlineSync', sidebarIcon: 'ri-refresh-line' },
   { id: 'nav-rep-ops-device-manifest', path: 'operations/device-sync-manifest', labelKey: 'nav.reports.deviceSyncManifest', sidebarIcon: 'ri-device-line' },
   { id: 'nav-rep-ops-drawer-recon', path: 'operations/drawer-reconciliation', labelKey: 'nav.reports.drawerReconciliation', sidebarIcon: 'ri-scales-3-line' },
  ],
 },
 {
  id: 'other',
  labelKey: 'reports.sections.other',
  items: [
   { id: 'nav-reports-legacy', path: 'legacy', labelKey: 'nav.reports.legacy', sidebarIcon: 'ri-file-list-line' },
   { id: 'nav-rep-saved', path: 'saved', labelKey: 'nav.reports.saved', sidebarIcon: 'ri-clipboard-fill' },
  ],
 },
]
